<template>
  <div class="AlertDetail">
    <el-card>
      <div class="AlertDetailContainer">
        <div class="alertdetail_titile">
          <div>

            <el-button @click="gotoBefore()" type="primary" plain round class="back">Back</el-button>
          </div>
          <h2>Alarm Details</h2>
        </div>
        <div style="display: flex;align-items: center;" class="noti_detail">
          <div class="noti_detail_title">{{ allAlertDetail.noti_detail }}</div>
          <div class="mainButton">
            <el-button type="info">{{ allAlertDetail.status_des }}</el-button>
          </div>
        </div>
        <div class="id_created">
          <p>Alarm ID：{{ allAlertDetail.id }}</p>
          <p>Create Time：{{ allAlertDetail.created_at }}</p>
        </div>
        <div class="warning_info">
          <div class="basic_title">
            <div>Alarm Information</div>
            <img src="@/assets/文本.png" alt="">
          </div>
          <div>
            <div class="issue">Problem：{{ allAlertDetail.des }}</div>
            <div class="content_attribute">
              <div class="warning_detail">
                <span>
                  Alarm Type：{{ allAlertDetail.type_name }}
                </span>
              </div>
              <div class="warning_detail">
                <span>
                  Alarm ID：{{ allAlertDetail.id }}
                </span>
              </div>
              <div class="warning_detail">
                <span>
                  The Module No.：{{ allAlertDetail.module_name }}
                </span>
              </div>
              <div class="warning_detail">
                <span>
                  Alarm Point：
                  <span v-for="item in allAlertDetail.tags_value" :key="item.tag">
                    {{ item.tag }}
                  </span>
                </span>
              </div>
              <div class="warning_detail">
                <span>
                  Point Value：
                  <span v-for="item in allAlertDetail.tags_value" :key="item.value">
                    {{ item.value }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="warning_info" v-if="status = 2">
          <div class="basic_title">
            <div>Process Information</div>
            <img src="@/assets/文本.png" alt="">
          </div>
          <div>
            <div class="content_attribute">
              <div class="warning_detail">
                <span>
                  Cause Description：{{ allAlertDetail.handle_reason }}
                </span>
              </div>
              <div class="warning_detail">
                <span>
                  Operation Description：{{ allAlertDetail.handle_action }}
                </span>
              </div>
              <div class="warning_detail">
                <span>
                  Operator：{{ allAlertDetail.handler }}
                </span>
              </div>
              <div class="warning_detail">
                <span>
                  Process Time：
                  {{ allAlertDetail.handle_at }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
// import config from '@/utils/config';
export default {
  data() {
    return {
      picChange: "",
      activeName: "first",
      routerDeid: "",
      modulesIndex: "",
      allAlertDetail: "",
      dialogFormVisible: false,
      ignoreRequest: {
        id: "",
        deal: null,
        reason: "",
      },
      finishRequest: {
        id: "",
        deal: null,
        reason: "",
      },
      handleInput: "",
      warningData: [],
      from: '',
      warningA: [],
      warningB: null,
      warningALG: null,
      gotoid: null
    };
  },
  sockets: {
    connect() {
      // console.log('socket connected');
    },

    warningAB(res) {
      this.warningA = []
      this.warningABCurrent = JSON.parse(res);
      if (this.warningABCurrent.A != []) {
        for (let i = 0; i < this.warningABCurrent.A.length; i++) {
          console.log(i);
          if (this.warningABCurrent.A[i].index != this.modulesIndex) {
            this.warningA.push(this.warningABCurrent.A[i])
          }
        }
        console.log(this.warningA);
      }
    },
  },
  created() {
    console.log('created');
    this.routerDeid = this.$route.query.id;
    console.log(this.routerDeid);
    if (this.$route.query.from) {
      this.from = this.$route.query.from
    } else {
      this.from = ''
    }
    this.lookDetail(this.routerDeid);
    this.modulesIndex = this.$route.query.index;
    this.getWarning(this.modulesIndex);
    this.picChange =
      JSON.parse(localStorage.getItem("theme")) == "light"
        ? "westeros"
        : "chalk";
  },
  mounted() { },
  watch: {

    "$store.state.theme"(newVal, oldVal) {
      this.picChange = newVal;
      console.log(this.picChange);
    },
  },

  beforeRouteUpdate(to, from, next) {
    console.log('to:', to, 'from', from);
    console.log('beforerouter');
    this.routerDeid = this.$route.query.id;
    this.lookDetail(to.query.id);
    next();
  },
  methods: {
    async lookDetail(detailId) {
      const { data: res } = await this.$http.get("/alarm/record/info", {
        params: { id: detailId },
      });
      if (res.code == 200) {
        this.allAlertDetail = res.data;
        console.log(this.allAlertDetail);
        return this.$message.success("Successfully retrieved alert details.");
      }
      // console.log(this.allAlertDetail.id);
    },


    gotoBefore() {
      this.gotoid = window.sessionStorage.getItem("waringid");
      if (this.from == 'control') {
        this.$router.push({
          path: "/openMore",
          query: { index: this.modulesIndex },
        });
      } else {
        this.$router.go(-1);
      }
    },

    async getWarning(index) {
      const { data: res } = await this.$http.get("/alarm/record/list", {
        params: { index: index },
      });
      this.warningData = res.data.data;
    },
    cardDetail(id, index, i) {
      this.$router.push({
        path: "/alertDetail",
        query: { id: id, index: index },
      });
      console.log('carddetail');
      // this.lookDetail(id);
    },

    handleMouseWheel(e) {
      const scrollLeft = document.querySelector(".cardAll").scrollLeft;
      const offsetWidth = document.querySelector(".cardAll").offsetWidth;
      const scrollWidth = document.querySelector(".cardAll").scrollWidth;
      if (e.wheelDelta < 0 && scrollLeft + offsetWidth < scrollWidth) {
        document.querySelector(".cardAll").scrollLeft =
          document.querySelector(".cardAll").scrollLeft + 100;
      } else if (e.wheelDelta > 0 && scrollLeft > 0) {
        document.querySelector(".cardAll").scrollLeft =
          document.querySelector(".cardAll").scrollLeft - 100;
      }
    },

    cardStyle(id) {
      // console.log(id);
      if (this.picChange == "westeros") {
        if (id === this.allAlertDetail.id) {
          return {
            backgroundColor: "#ecf5ff",
            color: "#3c3c3c",
            borderColor: "#b3d8ff",
          };
        }
      } else if (this.picChange == "chalk") {
        if (id === this.allAlertDetail.id) {
          return {
            backgroundColor: "#383838",
            color: "#e5e5e5",
            borderColor: "#111",
          };
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AlertDetail {
  margin-right: 15px;
  margin-left: 15px;

  .AlertDetailContainer {
    margin: 25px;

    .alertdetail_titile {
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(219, 219, 219, 1);

      h2 {
        margin-left: 20px;
      }
    }

    .noti_detail {
      margin-top: 20px;

      .noti_detail_title {
        font-size: 20px;
        font-weight: 600;
      }
    }

    .id_created {
      display: flex;
      border-bottom: 1px solid rgba(219, 219, 219, 1);

      p {
        margin-right: 20px;
      }
    }

    .warning_info {
      margin-top: 20px;

      .content_attribute {
        margin-bottom: 20px;
        padding-top: 20px;
        margin-left: 20px;
        // margin-top: 10px;
        // border-top: 1px solid rgba(219, 219, 219, 1);

        .warning_detail {
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: 400;
          // letter-spacing: 0px;
          // line-height: 0px;
          color: rgba(103, 103, 103, 1);
        }
      }
    }

    .basic_title {
      display: flex;
      align-items: center;
      // justify-content: center;
      height: 21px;
      opacity: 1;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 20.27px;
      color: rgba(36, 102, 168, 1);
      // margin-bottom: 20px;

      img {
        height: 16px;
        margin-left: 6px;
      }
    }
  }

  .issue {
    margin-top: 30px;
    font-weight: 600;
    font-size: 20px;
    color: #409eff;
  }

  .explain {
    margin-top: 60px;
    font-weight: 600;
  }

  .reason {
    margin-top: 16px;
  }

  .handle {
    margin-top: 40px;
  }

  .el-card {
    border-radius: 20px !important;
    border: 0;
  }

  h3 {
    display: inline-block;
  }

  .detailMd {
    display: block;
    margin-top: 0;
  }

  .mainButton {
    float: right;
    display: inline-table;
    margin-right: 60px !important;
  }

  .el-button {
    margin-left: 30px !important;
  }

  .back {
    margin-left: 0px !important;
  }

  .el-tabs {
    margin-top: 50px;
  }

  .explainInput {
    margin-top: 40px;
    font-weight: 600;
  }

  .cardAll {
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;

    .title {
      // margin-top: 20px;
      margin-bottom: 20px;
      margin-left: 20px;
      font-size: 20px;
      font-weight: 600;
    }

    .alertCard {
      display: inline-block;
      box-sizing: border-box;
      // margin-top: 40px;
      margin-right: 40px;
      margin-bottom: 30px;
      width: 25%;
      height: 160px;

      // color: #3c3c3c;
      h3 {
        margin-left: 20px;
      }

      h4 {
        margin-left: 20px;
      }
    }

    .alertCard:hover {
      transform: scale(1.1);
    }
  }

  .v-enter,
  .v-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }

  .v-enter-active,
  .v-leave-active {
    transition: all 0.6s cubic-bezier(0.42, 0, 0.58, 1);
  }

  .v-move {
    transition: all 0.6s cubic-bezier(0.42, 0, 0.58, 1);
  }

  .v-leave-active {
    position: absolute;
  }

  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
